<template>
    <el-time-picker
        v-bind:class="type === isType ? (value ? 'success' : 'danger') : ''"
        align="left"
        class="time-picker"
        v-bind:title="titleForValue"
        placeholder="Select time"
        v-model="value"
        @change="onChange(type, name, $event)"
        format="hh:mm A"
        size="small"
        v-if="type === 'hours' || !data"></el-time-picker>
    <span v-else>{{ data }}</span>
</template>
<script>
    export default {
        name: 'resolve-time',
        data() {
            return {
                value: ""
            }
        },
        computed: {
            titleForValue() {
                if (!this.value) {
                    return ""
                }
                const date = new Date(this.value)
                const hourFormat = date.getHours() > 12 ? "PM" : "AM"
                let hours = date.getHours()
                let minutes = date.getMinutes()
                hours = hours % 12
                hours = hours ? hours : 12 // the hour '0' should be '12'
                hours = hours < 12 ? '0' + hours : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                const t = `${hours}:${minutes} ${hourFormat}`
                return t
            }
        },
        props: {
            isType: {
                type: String,
                required: true
            },
            data: {
                type: [String, Boolean],
                required: true
            },
            type: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            }
        },
        methods: {
            onChange(type, name, event) {
                this.$emit('changeTime', {
                    type,
                    name,
                    event: new Date(event).getHours() + ':' + new Date(event).getMinutes()
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .time-picker {
        width: 130px !important;
    }
    .success {
        input {
            border-color: rgb(103, 194, 58) !important;
            background-color: #f6fff8;
        }
    }

    .danger {
        input {
            border-color: rgb(245, 108, 108) !important;
        }
    }
</style>